import React, {} from "react";
import '../App.css';
import axios from 'axios'
import Bootstrap, {
    Form,
    Row,
    Col,
    Button
} from 'bootstrap-4-react';
import {useInput} from '../useInput'
import shield from '../shield.svg'
import ThanksModal from "./ThanksModal";

function Registration({eventDate}) {


    const SendToBitrix = data => {
        const urlBitrix = 'sendBitrix.php'

        axios.post(urlBitrix, {
            email: data.email,
            name: data.name,
            phone: data.phone,
            time: eventDate.date + ' ' + eventDate.time
        }).then((answer) => {
            console.log(answer)
        }).catch(() => {
            console.log('POST Something Wrong')
        })
    }

    const SendData = data => {

        const urlGoogle = 'https://script.google.com/macros/s/AKfycbzAaXm9Xxiz22i7n2idyLTl6PakZUcmOousu2VKdF3gntWyrkk/exec'
        axios({
            method: 'GET',
            url: urlGoogle + '?date=' + Date() + '&name=' + data.name + '&email=' + data.email + '&phone=' + data.phone + '&event=' + 'works',
        }).then(() => {
            console.log('All OK')
        }).catch(() => {
            console.log('Something Wrong')
        })
    }

    const {value: name, bind: bindName, reset: resetName} = useInput('');
    const {value: email, bind: bindEmail, reset: resetEmail} = useInput('');
    const {value: phone, bind: bindPhone, reset: resetPhone} = useInput('');


    const handleSubmit = (evt) => {
        evt.preventDefault();

        const data = {
            name,
            email,
            phone
        }

        SendData(data)

        SendToBitrix(data)

        resetName();
        resetEmail();
        resetPhone();

        Bootstrap.modal('#Modal');
    }

    return (
        <Row id="cRow">
            <Col col="lg-4">
                <h3 className="rowTitle">Получите приглашение</h3>
                <p>Заполните форму регистрации и мы пришлём вам ссылку для доступа к вебинару, а также напомним о
                    его проведении. <br /><br /><strong>Все новые зарегистрировавшиеся дополнительно получат таблицу-шаблон для финансового учёта объекта.</strong></p>

            </Col>
            <Col col="lg-8">
                <div id="form">
                    <ThanksModal/>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Input
                                className="formInput"
                                type="text"
                                id="InputName"
                                placeholder="Ваше имя"
                                {...bindName}
                                required
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input
                                className="formInput"
                                type="email"
                                id="InputEmail"
                                placeholder="E-mail для приглашения"
                                {...bindEmail}
                                required
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Input
                                className="formInput"
                                type="tel"
                                id="InputPhone"
                                placeholder="Телефон для напоминания"
                                {...bindPhone}
                                required
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Check>
                                <Form.CheckInput
                                    type="checkbox"
                                    id="Check"
                                    required
                                />
                                <Form.CheckLabel htmlFor="Check">Соглашаюсь на обработку персональных
                                    данных</Form.CheckLabel>
                            </Form.Check>
                        </Form.Group>
                        <Button data-toggle="modal" success type="submit">Зарегистрироваться</Button>
                    </Form>
                    <br/>
                    <div id="shield">
                        <img src={shield} alt="logo" height="30"/>
                        <p>Мы не передаём ваши данные третьим лицам и полностью соблюдаем законы РФ</p>
                    </div>
                </div>

            </Col>
        </Row>
    )
}

export default Registration
